import styled from 'styled-components';

const Bottom = styled.div`
  display: flex;
`;

export default Bottom;
